export default __webpack_public_path__ + "static/media/cta-icon.49b9063b.svg";